import FontBody3 from '../../../../../components/fonts/font-body3/font-body3';
import { FONT_COLOR } from '../../../../../components/fonts/font-props';
import IconEye from '../../../../../components/icons/icon-eye/icon-eye';
import Icon from '../../../../../components/icons/icon/icon';

interface IProps {
    label: string;
    onClick: () => void;
    disabled?: boolean;
}

const RmaShopperRevealButton: React.FC<IProps> = ({ label, onClick, disabled = false }) => (
    <button
        type="button"
        className="rma-shopper-reveal-button"
        onClick={onClick}
        disabled={disabled}
    >
        <Icon Component={IconEye} />
        <FontBody3 color={FONT_COLOR.ACCENT1}>{label}</FontBody3>
    </button>
);

export default RmaShopperRevealButton;
